import { useNotification } from '@/hooks';
import { useCreateTypeMutation, useUpdateTypeMutation } from '../service';
import { TypeSchema } from '../models';
import { NotificationSeverity } from '@/components/notifications/Notification';

const useTypesActions = () => {
  const [createType, { isLoading: isCreatingType }] = useCreateTypeMutation();
  const [updateType, { isLoading: isUpdatingType }] = useUpdateTypeMutation();

  const { showNotification } = useNotification();

  const onCreateType = async (data: TypeSchema, reset: () => void) => {
    try {
      const result = await createType({ name: data.name }).unwrap();
      showNotification(
        'Tipo creado correctamente',
        NotificationSeverity.success
      );
      reset();
      return result;
    } catch (error: any) {
      console.error('Error creating type:', error);
      showNotification(
        'Ocurrió un error al crear el tipo. Inténtalo nuevamente.',
        NotificationSeverity.error
      );
      throw error; 
    }
  };

  const onUpdateType = async (
    typeId: string,
    data: TypeSchema,
    reset: () => void
  ) => {
    try {
      await updateType({ typeId, body: { name: data.name } }).unwrap();
      showNotification(
        'Tipo actualizado correctamente',
        NotificationSeverity.success
      );
      reset();
    } catch (error: any) {
      console.error('Error updating type:', error);
      showNotification(
        'Ocurrió un error al actualizar el tipo. Inténtalo nuevamente.',
        NotificationSeverity.error
      );
    }
  };

  return {
    isCreatingType,
    isUpdatingType,
    onCreateType,
    onUpdateType,
  };
};

export default useTypesActions; 